import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessPermissionGuard, AuthGuard } from '@osos/shared/legacy-core';
import {
  AccessRightLevelEnum,
  AppContext,
  EntitlementMode,
  REFRESH_PAGE_ROUTE,
} from '@osos/shared/types';
import { AuthCallbackComponent } from './pages/auth-callback/auth-callback.component';
import { NoAccessComponent } from './pages/no-access/no-access.component';
import { RefreshComponent } from './pages/refresh/refresh.component';
import { WelcomePageComponent } from './pages/welcome-page/welcome-page.component';

// TODO: Set up wildcard routes for 404 not-found page.

const routes: Routes = [
  {
    path: 'user',
    canLoad: [AuthGuard],
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
  },
  {
    path: 'welcome',
    data: {
      appContext: AppContext.Public,
      access: EntitlementMode.System,
      level: AccessRightLevelEnum.None,
    },
    canActivate: [AuthGuard, AccessPermissionGuard],
    component: WelcomePageComponent,
  },
  {
    path: 'admin',
    data: {
      access: EntitlementMode.System,
      level: AccessRightLevelEnum.ViewAccess,
      breadcrumb: 'BCRUMB.ADMINISTRATION',
    },
    canLoad: [AuthGuard, AccessPermissionGuard],
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent,
  },
  {
    path: REFRESH_PAGE_ROUTE,
    component: RefreshComponent,
  },
  {
    path: '403',
    component: NoAccessComponent,
  },
  {
    path: 'unauthorized',
    redirectTo: '/403',
  },
  {
    path: '',
    loadChildren: () =>
      import('./public/public.module').then((m) => m.PublicModule),
  },
  {
    path: ':moduleId',
    pathMatch: 'full',
    redirectTo: 'admin/:moduleId',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
